import { useState, useRef, useEffect } from 'react'

let timer

function useCountDown(countFrom, cb) {
  const [count, updateCount] = useState(0)
  const countRef = useRef(count)
  countRef.current = count

  function tic() {
    timer = setTimeout(() => {
      updateCount(countRef.current - 1)
      if (countRef.current <= 0) {
        clearTimeout(timer)
        cb && cb()
        return
      }
      tic()
    }, 1000)
  }

  function startCounter() {
    updateCount(countFrom)
    tic()
  }

  function resetCounter() {
    updateCount(0)
    clearTimeout(timer)
  }

  useEffect(() => {
    return function cleanUp() {
      clearTimeout(timer)
    }
  }, [])

  return {
    count,
    startCounter,
    resetCounter

  }
}

export default useCountDown
